<template>
  <div class="lms-wrapper-two">

    <student-nav @route-changed="toggleNavbar(false)">
                <notif-search
                  v-if="searchRdy"
                  :searches="searches"
                  :tasks="tasks"
                  :allCount="allCount"
                  class="mg-t-40"
                  @on-search="search($event)"
                  @on-reset="init(true)"
                  :key="searchKey"
                />
              </student-nav>

    
    <!-- <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${getScrollHeight()}`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div> -->
    <div class="lms-content">
      <student-header
      @toggle-navbar="toggleNavbar($event)"
      :navbarmode.sync="navbarMode"
    />

      <div class="lms-content-body container" style="bottom: 0; height: calc(100vh - 80px)">
        <section v-if="$route.params.id == 0">

          <div class="pos-fixed b-10 r-10" style="z-index: 1;">
            <a @click="filterObj.mdl= true" role="button" class="btn btn-primary btn-xs btn-uppercase">Хайх</a>
          </div>

          <vue-custom-scrollbar
            :style="`height: ${getScrollHeight()}`"
            class="bg-white"
          >
            <template v-if="$store.state.app.isMobile">
              <div class="card" style="min-height: 100%">
                <div
                  class="card-header d-flex align-items-center justify-content-between"
                >
                  <h6 class="mg-b-0">Тушаал / цахилгаан</h6>
                </div>
                <ul class="list-group list-group-flush tx-13">
                  <li
                    @click="
                      $router.push({
                        name: 'lmsNotif',
                        params: {
                          id: t.secondAttachmentId,
                          cid: 0,
                          title: t.task
                        }
                      })
                    "
                    class="list-group-item d-flex clearfix pd-sm-x-20"
                    v-for="(t, i) in tasks"
                    :key="i"
                  >
                    <div class="avatar" style="min-width: 40px">
                      <!-- :style="{'background-color': t.locTypeCode}" -->
                      <span
                        v-if="t.locTypeName != null && t.locTypeName != ''"
                        class="avatar-initial rounded-circle bg-info"
                      >
                        {{ t.locTypeName.substring(0, 1) }}
                      </span>
                      <span
                        v-else
                        class="avatar-initial rounded-circle bg-gray-600"
                        ><feather type="list" class="ht-20-f wd-20-f"></feather
                      ></span>
                    </div>
                    <div class="pd-l-10">
                      <p class="tx-medium mg-b-0">{{ t.task }}</p>
                      <small class="tx-12 tx-color-03 mg-b-0">{{
                        t.locTypeName
                      }}</small>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
            <template v-else>
              <table
                class="table table-striped table-hover table-sm table-responsive"
              >
                <thead>
                  <tr>
                    <th scope="col" class="wd-50">Д/д</th>
                    <th scope="col">Дугаар</th>
                    <th scope="col">Товч утга</th>
                    <th scope="col">Төрөл</th>
                    <th scope="col" class="wd-90">-</th>
                  </tr>
                </thead>
                <tbody v-if="tasks.length">
                  <tr
                    @click="
                      $router.push({
                        name: 'lmsNotif',
                        params: {
                          id: t.secondAttachmentId,
                          cid: 0,
                          title: t.task
                        }
                      })
                    "
                    v-for="(t, i) in tasks"
                    :key="i"
                    role="button"
                  >
                    <th scope="row" class="tx-color-03">{{ i + 1 }}</th>
                    <td class="font-weight-bolder">{{ t.taskEn }}</td>
                    <td>{{ t.task }}</td>
                    <td class="tx-color-03">{{ t.locTypeName }}</td>
                    <td>
                      <router-link
                        :to="{ 
                          name: 'lmsNotif',
                          params: {
                            id: t.secondAttachmentId,
                            cid: 0,
                            title: t.task
                          }
                        }"
                      >
                        <feather type="paperclip" class="mg-r-5"></feather>
                        харах
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="wd-100p">
                      <div
                        class="container d-flex justify-content-center ht-100p"
                      >
                        <div
                          class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
                        >
                          <div class="wd-80p wd-sm-300 mg-b-15">
                            <img
                              src="assets/svg/boxempty.svg"
                              alt=""
                              class="img-fluid"
                            />
                          </div>
                          <h4 class="tx-20 tx-sm-24 text-muted">
                            Мэдээлэл хоосон байна
                          </h4>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </vue-custom-scrollbar>
        </section>
        <section v-if="$route.params.id > 0">
          <div class="mg-b-20 pd-b-10 bd-b d-flex align-items-center">
            <router-link
              :to="{
                name: 'lmsNotif',
                params: { id: 0, cid: 0, title: 'Тушаал Цахилгаан' }
              }"
            >
              <feather type="chevron-left" class="mg-r-10"></feather>
            </router-link>
            <h6 class="tx-uppercase tx-semibold mg-b-0 wd-80p">
              {{ $route.params.title }}
            </h6>
            <div class="d-flex align-items-center  wd-20p">
              <div class="mg-l-auto">
                <a
                  v-if="fileData.fetched"
                  target="_blank"
                  :href="fileData.link"
                  class="btn btn-xs btn-success"
                  ><feather type="download"></feather> татах</a
                >
              </div>
            </div>
          </div>

          <file-preview
            @on-data-fetched="fileDataFetched"
            :id.sync="$route.params.id"
            :params="$route.params"
            force
            :minusHeight="$store.state.app.isMobile ? 140 : 180"
          />
        </section>
      </div>
    </div>

    <b-modal title="Хайх" hide-footer v-model="filterObj.mdl" centered>
      <notif-search
        v-if="searchRdy"
        :searches="searches"
        :tasks="tasks"
        :allCount="allCount"
        class="mg-t-40"
        @on-search="search($event)"
        @on-reset="init(true)"
        :key="searchKey"
      />
      <!-- <form>
        <div class="form-group row mg-b-0">
          <label class="col-sm-4 col-form-label d-flex align-items-center">Дугаар</label>
          <div class="col-sm-8"><input type="text" class="form-control"></div>
        </div>
        <div class="form-group row mg-b-0">
          <label class="col-sm-4 col-form-label d-flex align-items-center">Товч утга</label>
          <div class="col-sm-8"><input type="text" class="form-control"></div>
        </div>
        <div class="form-group row mg-b-0">
          <div class="col-sm-12 text-right">
            <a @click="resetFilter()" role="button" class="btn btn-default"> Бүгд </a>
            <a role="button" class="btn btn-primary"> Хайх </a>
          </div>
        </div>
      </form> -->
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

import { request } from "@/api/all";
export default {
  components: {
    vueCustomScrollbar,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    notifSearch: () => ({
      component: import(
        "@/views/modules/lms/student/pages/notif/components/search.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      filterObj:{
        mdl: false,
      },
      navbarMode: 0,
      tasks: [],
      allCount: 0,
      searches: [],
      searchRdy: false,
      searchKey: 0,
      filterModel: {
        task: "",
        systemFlag: null
      },
      fileData: {
        fetched: false,
        link: ""
      }
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");
    this.init();
    this.initSearches();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    resetFilter(){

    },
    fileDataFetched(e) {
      this.fileData.link = e.data.file.link;
      this.fileData.fetched = true;
      //console.log(e);
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getScrollHeight() {
      let mh = 120;
      if (screen.width <= 1024) {
        mh = 85;
      }
      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
    search(e) {
      this.navbarMode = 1;
      this.toggleNavbar(false);
      if (this.$route.params.id > 0) {
        this.$router.push({
          name: "lmsNotif",
          params: { id: 0, cid: 0, title: "Тушаал Цахилгаан" }
        });
      } else {
        this.filterModel = e;
        this.init();
      }
    },
    init(force) {
      if (force) {
        if (this.$route.params.id > 0) {
          this.$router.push({
            name: "lmsNotif",
            params: { id: 0, cid: 0, title: "Тушаал Цахилгаан" }
          });
        } else {
          this.filterModel = { task: "", systemFlag: null };
          this.searchKey++;
          this.navbarMode = 1;
          this.toggleNavbar(false);
        }
      }
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 300,
          ot: 159,
          model: this.filterModel
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log(res);
          this.allCount = res.data.allCount;
          this.tasks = res.data.tasks;
        }
      });
    },
    initSearches() {
      console.log('01');
      request({
        api: { method: "GET", url: "TaskCore/GetSearchFields" },
        params: {
          objectTypeId: 159
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.searches = res.data.fields.map(e =>
            Object.assign(e, { val: "" })
          );
          console.log('02');
          this.searchRdy = true;
        }
      });
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.init();
        });
      }
    }
  }
};
</script>

<style></style>
